import React from 'react';
import { Navbar } from '../../components/Navbar';

import ResourcesBG from '../../assets/ResourcesBG.jpg';
import { ContentBox } from '../../components/ContentBox';
import { useTranslation } from 'react-i18next';

import biochar_title from '../../assets/biochar_title_screen.png';

const ResourcesPage = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-sky-200">
      <Navbar src={ResourcesBG} pageName={t('resourcesPage.navbar.pageName')} />

      <ContentBox
        bgColor={'#CFE3F6'}
        titleColor={'#2E7A32'}
        title={t('resourcesPage.contentBox.fundingTitle')}
        content={
          <div>
            {t('resourcesPage.contentBox.fundingIntro')}
            <ul className={`list-inside indent-3 inset-1`} style={{ listStyleType: 'square' }}>
              <li>
                {t('resourcesPage.contentBox.bulletOne')}{' '}
                <a
                  href="https://www.elevatedfoods.com/pages/climate-smart-commodities"
                  target="partner"
                  className="text-lime-700 hover:text-emerald-700 hover:underline"
                >
                  {t('resourcesPage.contentBox.links.climateSmart')}
                </a>
                .
              </li>
              <li>
                {t('resourcesPage.contentBox.bulletTwo')}{' '}
                <a
                  href="https://www.zerofoodprint.org/compost"
                  target="partner"
                  className="text-lime-700 hover:text-emerald-700 hover:underline"
                >
                  {t('resourcesPage.contentBox.links.compostGrants')}
                </a>
                .
              </li>
              <li>
                {t('resourcesPage.contentBox.bulletThree')}{' '}
                <a
                  href="https://www.zerofoodprint.org/apply"
                  target="partner"
                  className="text-lime-700 hover:text-emerald-700 hover:underline"
                >
                  {t('resourcesPage.contentBox.links.restoreGrants')}
                </a>
                .
              </li>
            </ul>
            <p>
              {t('resourcesPage.contentBox.fundingOutro1')}{' '}
              <a
                href="https://carcd.org/page/interactive-rcd-map"
                target="partner"
                className="text-lime-700 hover:text-emerald-700 hover:underline"
              >
                {t('resourcesPage.contentBox.rcdLink')}
              </a>{' '}
              {''}
              {t('resourcesPage.contentBox.fundingOutroPart2')}
            </p>
          </div>
        }
        maxContentWidth="max-w-7xl"
      />
      {/* Climate Smart Section */}
      <ContentBox
        bgColor="#A8C356"
        title={t('resourcesPage.climateSmart.title')}
        titleColor="#2E7A32"
        content={
          <div>
            <p>
              {t('resourcesPage.climateSmart.intro1')}
              {}
              <strong>{t('resourcesPage.climateSmart.carbon_farming_label')}</strong>
              {t('resourcesPage.climateSmart.intro2')}
            </p>
            &nbsp; &nbsp;
            <p>
              <h1 className={`font-bold text-2xl text-lime-800`}>
                {t('resourcesPage.climateSmart.benefitsTitle')}
              </h1>
              <p>{t('resourcesPage.climateSmart.problemsIntro')}</p>
              <ul className={`list-inside indent-3 inset-1`} style={{ listStyleType: 'square' }}>
                <li>{t('resourcesPage.climateSmart.benefits.erosion')}</li>
                <li>{t('resourcesPage.climateSmart.benefits.water')}</li>
                <li>{t('resourcesPage.climateSmart.benefits.inputs')}</li>
                <li>{t('resourcesPage.climateSmart.benefits.pollution')}</li>
                <li>{t('resourcesPage.climateSmart.benefits.fossilFuels')}</li>
              </ul>
            </p>
            &nbsp;
            <p>
              {t('resourcesPage.climateSmart.profits1')}
              {''}
              <strong>{t('resourcesPage.climateSmart.bolded_profits')}</strong>
              {t('resourcesPage.climateSmart.profits2')}
            </p>
            &nbsp;
            <p>
              <h1 className={`font-bold text-2xl text-lime-800`}>
                {t('resourcesPage.climateSmart.moreInfoTitle')}
              </h1>
              <ul className={`list-inside indent-3 inset-1`} style={{ listStyleType: 'square' }}>
                <li>
                  {t('resourcesPage.climateSmart.moreInfo.rcd1')}{' '}
                  <a
                    href="https://carcd.org/page/interactive-rcd-map"
                    target="partner"
                    className="text-lime-700 hover:text-emerald-700 hover:underline"
                  >
                    {t('resourcesPage.climateSmart.moreInfo.rcdLink')}
                  </a>
                  {''}
                  {t('resourcesPage.climateSmart.moreInfo.rcd2')}
                </li>
                <li>
                  {t('resourcesPage.climateSmart.moreInfo.cci1')}{' '}
                  <a
                    href="https://www.carboncycle.org/what-is-carbon-farming/"
                    target="partner"
                    className="text-lime-700 hover:text-emerald-700 hover:underline"
                  >
                    {t('resourcesPage.climateSmart.moreInfo.cciLink')}
                  </a>
                  {''}
                  {t('resourcesPage.climateSmart.moreInfo.cci2')}
                </li>
                <li>
                  {t('resourcesPage.climateSmart.moreInfo.biochar')}{' '}
                  <a href="https://www.youtube.com/watch?v=-ogN_toQ-30" target="video">
                    <img
                      className={`w-[400px] mx-auto my-4`}
                      src={biochar_title}
                      alt="The Impact of Biochar"
                    />
                  </a>
                </li>
              </ul>
            </p>
          </div>
        }
        // contentColor="#FFFFFF"
        maxContentWidth="max-w-7xl"
      />
      {/* <ContentBox
        bgColor="#FFFFFF"
        title="Carbon farming"
        content={
          <div>
            <p>Contact your local <a href="https://carcd.org/page/interactive-rcd-map"  target="partner"
                className="text-lime-700 hover:text-emerald-700 hover:underline">Resource Conservation District</a> to learn more about climate-smart agriculture.</p>
            &nbsp;
            <p><img className={`w-[800px] mx-auto my-4`} src={CarbonFarmSketch} alt="The traditional process of project development for Conservation Districts." /></p>
            &nbsp;
            <p>
              The carbon farm plan was developed by <a href='https://www.carboncycle.org/' target='partners'>Carbon Cycle Institute</a>.
            </p>
          </div>
        }
        colorContent="#000000"
      /> */}
    </div>
  );
};

export { ResourcesPage };
